import { Directive, HostListener, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SocialShareDirective = /** @class */ (function () {
    function SocialShareDirective() {
    }
    /**
     * @return {?}
     */
    SocialShareDirective.prototype.onMouseEnter = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ url = encodeURIComponent(window.location.href);
        switch (this.socialShare) {
            case 'fb':
                window.open("https://www.facebook.com/sharer/sharer.php?u=" + url);
                break;
            case 'tw':
                window.open("https://twitter.com/home?status=" + url);
                break;
            case 'in':
                window.open("https://www.linkedin.com/sharing/share-offsite/?url=" + url);
                break;
            case 'tr':
                window.open("https://www.tumblr.com/widgets/share/tool?canonicalUrl=" + url);
                break;
            case 'rd':
                window.open("https://reddit.com/submit?url=" + url);
                break;
            case 'pn':
                window.open("https://www.pinterest.com/pin/find/?url=" + url);
                break;
            default:
                break;
        }
    };
    SocialShareDirective.decorators = [
        { type: Directive, args: [{ selector: '[socialShare]' },] },
    ];
    /** @nocollapse */
    SocialShareDirective.propDecorators = {
        "socialShare": [{ type: Input, args: ['socialShare',] },],
        "onMouseEnter": [{ type: HostListener, args: ['click',] },],
    };
    return SocialShareDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var NgxSocialShareModule = /** @class */ (function () {
    function NgxSocialShareModule() {
    }
    NgxSocialShareModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [
                        SocialShareDirective
                    ],
                    exports: [
                        SocialShareDirective
                    ]
                },] },
    ];
    return NgxSocialShareModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgxSocialShareModule, SocialShareDirective as ɵa };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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